import { SearchEngineDataService } from '../../_services/search-engine-data.service';
import { Component, OnInit, Optional } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  constructor(@Optional() private metaDataService: SearchEngineDataService) { }

  ngOnInit(): void {
    if (this.metaDataService) {
      this.metaDataService.updateMetadata({
        title: 'About boldungu team for mathematics',
        description: 'Fun with mathematics for primary school children'
      });
    }
  }

}
